import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Layout from '../components/Layout/Layout';
import RuleListPage from '../RuleListPage/RuleListPage';

const StageTransitionRulesLayout = () => {
  return (
    <Routes>
        <Route element={<Layout />}>
            <Route index element={<RuleListPage />} />
        </Route>
    </Routes>
  );
};

export default StageTransitionRulesLayout;
